export const app_permissions = {
    workspace: {
        petty_cash: {
            view: 'workspace.petty-cash.view',
            manage: 'workspace.petty-cash.manage',
        },
    },
    operations: {
        fieldWork: {
            view: 'operations.fieldwork.view',
            manage: 'operations.fieldwork.manage',
            release: 'operations.fieldwork.release',
            assign: 'operations.fieldwork.assign',
            execute: 'operations.fieldwork.execute',
            approve: 'operations.fieldwork.approve',
            override: 'operations.fieldwork.override',
            financeView: 'operations.fieldwork.finance.view',
            financeGenerate: 'operations.fieldwork.finance.generate',
        },
        equipment: {
            view: 'operations.equipment.view',
            manage: 'operations.equipment.manage',
            checkout: 'operations.equipment.checkout',
            ratesView: 'operations.equipment.rates.view',
            ratesManage: 'operations.equipment.rates.manage',
        },
    },
    accounts: {
        petty_cash: {
            boxes_manage: 'accounts.petty-cash.boxes.manage',
        },
        journal: {
            create: 'accounts.journal.create',
            edit: 'accounts.journal.edit',
            view: 'accounts.journal.view',
            delete: 'accounts.journal.delete',
            approve: 'accounts.journal.approve',
            post: 'accounts.journal.post',
            cancel: 'accounts.journal.cancel',
            void: 'accounts.journal.void',
            reverse: 'accounts.journal.reverse',
            hold: 'accounts.journal.hold',
            release: 'accounts.journal.release',
            close: 'accounts.journal.close',
        },
        receipt: {
            create: 'accounts.receipt.create',
            edit: 'accounts.receipt.edit',
            view: 'accounts.receipt.view',
            delete: 'accounts.receipt.delete',
            approve: 'accounts.receipt.approve',
            post: 'accounts.receipt.post',
            cancel: 'accounts.receipt.cancel',
            void: 'accounts.receipt.void',
            reverse: 'accounts.receipt.reverse',
            hold: 'accounts.receipt.hold',
            release: 'accounts.receipt.release',
            close: 'accounts.receipt.close',
        },
        debit_note: {
            create: 'accounts.debit-note.create',
            edit: 'accounts.debit-note.edit',
            view: 'accounts.debit-note.view',
            delete: 'accounts.debit-note.delete',
            approve: 'accounts.debit-note.approve',
            post: 'accounts.debit-note.post',
            cancel: 'accounts.debit-note.cancel',
            void: 'accounts.debit-note.void',
            reverse: 'accounts.debit-note.reverse',
            hold: 'accounts.debit-note.hold',
            release: 'accounts.debit-note.release',
            close: 'accounts.debit-note.close',
        },
        credit_note: {
            create: 'accounts.credit-note.create',
            edit: 'accounts.credit-note.edit',
            view: 'accounts.credit-note.view',
            delete: 'accounts.credit-note.delete',
            approve: 'accounts.credit-note.approve',
            post: 'accounts.credit-note.post',
            cancel: 'accounts.credit-note.cancel',
            void: 'accounts.credit-note.void',
            reverse: 'accounts.credit-note.reverse',
            hold: 'accounts.credit-note.hold',
            release: 'accounts.credit-note.release',
            close: 'accounts.credit-note.close',
        },
        customer_credit_note: {
            view: 'accounts.customer-credit-note.view',
            create: 'accounts.customer-credit-note.create',
            edit: 'accounts.customer-credit-note.edit',
            approve: 'accounts.customer-credit-note.approve',
            post: 'accounts.customer-credit-note.post',
            cancel: 'accounts.customer-credit-note.cancel',
            reverse: 'accounts.customer-credit-note.reverse',
            allocate: 'accounts.customer-credit-note.allocate',
        },
        vendor_debit_note: {
            view: 'accounts.vendor-debit-note.view',
            create: 'accounts.vendor-debit-note.create',
            edit: 'accounts.vendor-debit-note.edit',
            approve: 'accounts.vendor-debit-note.approve',
            post: 'accounts.vendor-debit-note.post',
            cancel: 'accounts.vendor-debit-note.cancel',
            reverse: 'accounts.vendor-debit-note.reverse',
            allocate: 'accounts.vendor-debit-note.allocate',
        },
        voucher: {
            create: 'accounts.voucher.create',
            edit: 'accounts.voucher.edit',
            view: 'accounts.voucher.view',
            delete: 'accounts.voucher.delete',
            approve: 'accounts.voucher.approve',
            post: 'accounts.voucher.post',
            cancel: 'accounts.voucher.cancel',
            void: 'accounts.voucher.void',
            reverse: 'accounts.voucher.reverse',
            hold: 'accounts.voucher.hold',
            release: 'accounts.voucher.release',
            close: 'accounts.voucher.close',
        },
        bank_account_entry: {
            create: 'accounts.bank-account-entry.create',
            edit: 'accounts.bank-account-entry.edit',
            view: 'accounts.bank-account-entry.view',
            delete: 'accounts.bank-account-entry.delete',
        },
        invoice: {
            create: 'accounts.invoice.create',
            edit: 'accounts.invoice.edit',
            view: 'accounts.invoice.view',
            delete: 'accounts.invoice.delete',
            approve: 'accounts.invoice.approve',
            post: 'accounts.invoice.post',
            cancel: 'accounts.invoice.cancel',
            void: 'accounts.invoice.void',
            reverse: 'accounts.invoice.reverse',
            hold: 'accounts.invoice.hold',
            release: 'accounts.invoice.release',
            close: 'accounts.invoice.close',
        },
        bill: {
            create: 'accounts.bill.create',
            edit: 'accounts.bill.edit',
            view: 'accounts.bill.view',
            delete: 'accounts.bill.delete',
            approve: 'accounts.bill.approve',
            post: 'accounts.bill.post',
            cancel: 'accounts.bill.cancel',
            void: 'accounts.bill.void',
            reverse: 'accounts.bill.reverse',
            hold: 'accounts.bill.hold',
            release: 'accounts.bill.release',
            close: 'accounts.bill.close',
        },
        cost_center: {
            create: 'accounts.cost-center.create',
            edit: 'accounts.cost-center.edit',
            view: 'accounts.cost-center.view',
            delete: 'accounts.cost-center.delete',
        },
        reports: {
            view: 'accounts.reports.view',
        },
        bank_reconciliation: {
            view: 'accounts.bank-reconciliation.view',
            import: 'accounts.bank-reconciliation.import',
            manage: 'accounts.bank-reconciliation.manage',
            submit: 'accounts.bank-reconciliation.submit',
            approve: 'accounts.bank-reconciliation.approve',
            close: 'accounts.bank-reconciliation.close',
            reopen: 'accounts.bank-reconciliation.reopen',
            cancel: 'accounts.bank-reconciliation.cancel',
        },
        period_lock: {
            manage: 'accounts.period-lock.manage',
        },
        manual_entry: {
            manage: 'accounts.manual-entry.manage',
            receipt_post: 'accounts.manual.receipt.post',
            voucher_post: 'accounts.manual.voucher.post',
            journal_post: 'accounts.manual.journal.post',
            invoice_post: 'accounts.manual.invoice.post',
            bill_post: 'accounts.manual.bill.post',
            debit_note_post: 'accounts.manual.debit-note.post',
            credit_note_post: 'accounts.manual.credit-note.post',
            allocation_post: 'accounts.manual.allocation.post',
        },
        banks: {
            create: 'accounts.banks.create',
            edit: 'accounts.banks.edit',
            view: 'accounts.banks.view',
            delete: 'accounts.banks.delete',
        },
        matching: {
            view: 'accounts.matching.view',
            manage: 'accounts.matching.manage',
        },
        payment_proposals: {
            view: 'accounts.payment-proposals.view',
            create: 'accounts.payment-proposals.create',
            approve: 'accounts.payment-proposals.approve',
            release: 'accounts.payment-proposals.release',
            cancel: 'accounts.payment-proposals.cancel',
        },
        vendor_reconciliation: {
            view: 'accounts.vendor-reconciliation.view',
            manage: 'accounts.vendor-reconciliation.manage',
        },
        workforce_finance: {
            view: 'accounts.workforce-finance.view',
            cash_manage: 'accounts.workforce-finance.cash.manage',
            earnings_manage: 'accounts.workforce-finance.earnings.manage',
            earnings_approve: 'accounts.workforce-finance.earnings.approve',
            rates_manage: 'accounts.workforce-finance.rates.manage',
            payouts_manage: 'accounts.workforce-finance.payouts.manage',
            recoveries_confirm: 'accounts.workforce-finance.recoveries.confirm',
            reports: 'accounts.workforce-finance.reports',
        },
        compliance: {
            view: 'accounts.compliance.view',
            manage: 'accounts.compliance.manage',
        }
    },
    shipments: {
        CREATE: 'shipments.create',
        edit: 'shipments.edit',
        party_correct: 'shipments.party.correct',
        view: 'shipments.view',
        import: 'shipments.import',
        delete: 'shipments.delete',
        cancel: 'shipments.cancel',
        workflow_override: 'shipments.workflow.override',
        finance: {
            post: 'shipments.finance.post',
        },
        pricing: {
            view: 'shipments.pricing.view',
        },
        internal_transport_costs: {
            view: 'shipment.internal-transport-costs.view',
            create: 'shipment.internal-transport-costs.create',
            edit: 'shipment.internal-transport-costs.edit',
            import: 'shipment.internal-transport-costs.import',
        },
        dashboard: {
            view: 'shipments.dashboard.view',
        },
        waypoints: {
            create: 'shipments.waypoints.create',
            edit: 'shipments.waypoints.edit',
            delete: 'shipments.waypoints.delete',
        },
        charges: {
            create: 'shipments.charges.create',
            edit: 'shipments.charges.edit',
            delete: 'shipments.charges.delete',
        },
        files: {
            create: 'shipments.files.create',
            delete: 'shipments.files.delete',
        },
        nominations: {
            create: 'shipments.nominations.create',
            notify: 'shipments.nominations.notify',
        },
        deliveries: {
            GENERATE: 'shipments.deliveries.generate',
            view: 'shipments.deliveries.view',
            edit: 'shipments.deliveries.edit',
            manage_stops: 'shipments.deliveries.stops.manage',
            delete: 'shipments.deliveries.delete',
            assign: 'shipments.deliveries.assign',
            invoke: 'shipments.deliveries.invoke',
            confirm: 'shipments.deliveries.confirm',
            site_operations: 'shipments.deliveries.site-operations',
        }
    },
    transport_planning: {
        releases: {
            view: 'transport-planning.releases.view',
            create: 'transport-planning.releases.create',
            import: 'transport-planning.releases.import',
        },
        plans: {
            view: 'transport-planning.plans.view',
            create: 'transport-planning.plans.create',
            optimize: 'transport-planning.plans.optimize',
            apply: 'transport-planning.plans.apply',
        }
    },
    container_tracking: {
        dashboard: {
            view: 'container-tracking.dashboard.view',
        },
        cases: {
            view: 'container-tracking.cases.view',
            create: 'container-tracking.cases.create',
            edit: 'container-tracking.cases.edit',
        },
        events: {
            create: 'container-tracking.events.create',
        },
        legs: {
            manage: 'container-tracking.legs.manage',
        },
        storage: {
            manage: 'container-tracking.storage.manage',
        },
        integrations: {
            manage: 'container-tracking.integrations.manage',
        },
        jobs: {
            create: 'container-tracking.jobs.create',
            edit: 'container-tracking.jobs.edit',
            view: 'container-tracking.jobs.view',
            delete: 'container-tracking.jobs.delete',
            update_status: 'container-tracking.jobs.update-status',
            upload_document: 'container-tracking.jobs.upload-document',
        },
        yards: {
            create: 'container-tracking.yards.create',
            edit: 'container-tracking.yards.edit',
            view: 'container-tracking.yards.view',
            delete: 'container-tracking.yards.delete',
        }
    },
    clearance: {
        dashboard: {
            view: 'clearance.dashboard.view',
        },
        records: {
            create: 'clearance.records.create',
            edit: 'clearance.records.edit',
            view: 'clearance.records.view',
            delete: 'clearance.records.delete',
        },
        services: {
            create: 'clearance.services.create',
            edit: 'clearance.services.edit',
            view: 'clearance.services.view',
            delete: 'clearance.services.delete',
        },
        charges: {
            create: 'clearance.charges.create',
            edit: 'clearance.charges.edit',
            delete: 'clearance.charges.delete',
        },
        files: {
            upload: 'clearance.files.upload',
            delete: 'clearance.files.delete',
        },
        status: {
            update: 'clearance.status.update',
        }
    },
    expense: {
        records: {
            create: 'expense.records.create',
            edit: 'expense.records.edit',
            view: 'expense.records.view',
            delete: 'expense.records.delete',
        },
        approval: {
            approve: 'expense.approval.approve',
            reject: 'expense.approval.reject',
            view: 'expense.approval.view',
            configure: 'expense.approval.configure',
        },
        posting: {
            view: 'expense.posting.view',
            post: 'expense.posting.post',
            unpost: 'expense.posting.unpost',
        },
        attachments: {
            upload: 'expense.attachments.upload',
            delete: 'expense.attachments.delete',
        }
    },
    location: {
        records: {
            create: 'location.records.create',
            edit: 'location.records.edit',
            view: 'location.records.view',
            delete: 'location.records.delete',
        }
    },
    fleet: {
        dashboard: {
            view: 'fleet.dashboard.view',
        },
        drivers: {
            create: 'fleet.drivers.create',
            edit: 'fleet.drivers.edit',
            view: 'fleet.drivers.view',
            delete: 'fleet.drivers.delete',
        },
        vehicles: {
            create: 'fleet.vehicles.create',
            edit: 'fleet.vehicles.edit',
            view: 'fleet.vehicles.view',
            delete: 'fleet.vehicles.delete',
        },
        ownership: {
            transfer: 'fleet.ownership.transfer',
        },
        documents: {
            view: 'fleet.documents.view',
            manage: 'fleet.documents.manage',
        },
        profitability: {
            view: 'fleet.profitability.view',
        },
        telematics: {
            view: 'fleet.telematics.view',
            manage: 'fleet.telematics.manage',
        },
        assignments: {
            create: 'fleet.assignments.create',
            edit: 'fleet.assignments.edit',
            view: 'fleet.assignments.view',
            delete: 'fleet.assignments.delete',
        },
        rental: {
            view: 'fleet.rental.view',
            manage: 'fleet.rental.manage',
            activate: 'fleet.rental.activate',
            financeView: 'fleet.rental.finance.view',
            rates: {
                view: 'fleet.rental.rates.view',
                manage: 'fleet.rental.rates.manage',
            },
            usage: {
                view: 'fleet.rental.usage.view',
                submit: 'fleet.rental.usage.submit',
                approve: 'fleet.rental.usage.approve',
            },
            settlement: {
                view: 'fleet.rental.settlement.view',
                manage: 'fleet.rental.settlement.manage',
                generate: 'fleet.rental.settlement.generate',
            },
            analytics: {
                view: 'fleet.rental.analytics.view',
            },
        },
        mobilization: {
            overview: {
                view: 'fleet.mobilization.overview.view',
            },
            records: {
                create: 'fleet.mobilization.records.create',
                edit: 'fleet.mobilization.records.edit',
                view: 'fleet.mobilization.records.view',
                delete: 'fleet.mobilization.records.delete',
                submit: 'fleet.mobilization.records.submit',
                approve: 'fleet.mobilization.records.approve',
                reject: 'fleet.mobilization.records.reject',
                activate: 'fleet.mobilization.records.activate',
                complete: 'fleet.mobilization.records.complete',
            },
            change_requests: {
                view: 'fleet.mobilization.change-requests.view',
                approve: 'fleet.mobilization.change-requests.approve',
                export: 'fleet.mobilization.change-requests.export',
            },
            history: {
                view: 'fleet.mobilization.history.view',
            },
            timesheets: {
                view: 'fleet.mobilization.timesheets.view',
            }
        },
        maintenance: {
            overview: {
                view: 'fleet.maintenance.overview.view',
            },
            requests: {
                view: 'fleet.maintenance.requests.view',
                create: 'fleet.maintenance.requests.create',
                edit: 'fleet.maintenance.requests.edit',
            },
            work_orders: {
                view: 'fleet.maintenance.work-orders.view',
                create: 'fleet.maintenance.work-orders.create',
                edit: 'fleet.maintenance.work-orders.edit',
                approve: 'fleet.maintenance.work-orders.approve',
                status: 'fleet.maintenance.work-orders.status',
                post_finance: 'fleet.maintenance.work-orders.post-finance',
                manage_parts: 'fleet.maintenance.work-orders.manage-parts',
            },
            programs: {
                view: 'fleet.maintenance.programs.view',
                manage: 'fleet.maintenance.programs.manage',
            },
            inspections: {
                view: 'fleet.maintenance.inspections.view',
                submit: 'fleet.maintenance.inspections.submit',
            },
            defects: {
                view: 'fleet.maintenance.defects.view',
                triage: 'fleet.maintenance.defects.triage',
                resolve: 'fleet.maintenance.defects.resolve',
            },
            parts: {
                view: 'fleet.maintenance.parts.view',
            },
            availability: {
                view: 'fleet.maintenance.availability.view',
                manage: 'fleet.maintenance.availability.manage',
            },
            finance: {
                view: 'fleet.maintenance.finance.view',
            },
            analytics: {
                view: 'fleet.maintenance.analytics.view',
            }
        }
    },
    chart_of_accounts: {
        accounts: {
            create: 'chart-of-accounts.accounts.create',
            edit: 'chart-of-accounts.accounts.edit',
            view: 'chart-of-accounts.accounts.view',
            delete: 'chart-of-accounts.accounts.delete',
        },
        import: {
            execute: 'chart-of-accounts.import.execute',
        }
    },
    contracts: {
        records: {
            create: 'contracts.records.create',
            edit: 'contracts.records.edit',
            view: 'contracts.records.view',
            delete: 'contracts.records.delete',
            approve: 'contracts.records.approve',
            activate: 'contracts.records.activate',
        },
        services: {
            create: 'contracts.services.create',
            edit: 'contracts.services.edit',
            view: 'contracts.services.view',
            delete: 'contracts.services.delete',
        },
        templates: {
            create: 'contracts.templates.create',
            edit: 'contracts.templates.edit',
            view: 'contracts.templates.view',
            delete: 'contracts.templates.delete',
        },
        revisions: {
            create: 'contracts.revisions.create',
            edit: 'contracts.revisions.edit',
            view: 'contracts.revisions.view',
            approve: 'contracts.revisions.approve',
        },
        rate_cards: {
            create: 'contracts.rate-cards.create',
            edit: 'contracts.rate-cards.edit',
            view: 'contracts.rate-cards.view',
            delete: 'contracts.rate-cards.delete',
        },
        documents: {
            view: 'contracts.documents.view',
            manage: 'contracts.documents.manage',
        }
    },
    customer: {
        records: {
            create: 'customer.records.create',
            edit: 'customer.records.edit',
            view: 'customer.records.view',
            delete: 'customer.records.delete',
        }
    },
    portal: {
        admin: {
            manage: 'portal.admin.manage',
        }
    },
    company: {
        records: {
            create: 'company.records.create',
            edit: 'company.records.edit',
            view: 'company.records.view',
            delete: 'company.records.delete',
        }
    },
    order: {
        records: {
            create: 'order.records.create',
            edit: 'order.records.edit',
            view: 'order.records.view',
            delete: 'order.records.delete',
            approve: 'order.records.approve',
            cancel: 'order.records.cancel',
        },
        fulfillment: {
            view: 'order.fulfillment.view',
            update: 'order.fulfillment.update',
        },
        receipts: {
            view: 'order.receipts.view',
            create: 'order.receipts.create',
            confirm: 'order.receipts.confirm',
        },
        products: {
            create: 'order.products.create',
            edit: 'order.products.edit',
            view: 'order.products.view',
            delete: 'order.products.delete',
        }
    },
    party: {
        records: {
            create: 'party.records.create',
            edit: 'party.records.edit',
            view: 'party.records.view',
            delete: 'party.records.delete',
        }
    },
    ai_chat: {
        view: 'ai-chat.view',
        send: 'ai-chat.send',
        manage: 'ai-chat.manage',
    },
    wasender: {
        chat: {
            view: 'wasender.chat.view',
            send: 'wasender.chat.send',
        },
        setup: {
            view: 'wasender.setup.view',
            manage: 'wasender.setup.manage',
        }
    },
    business_events: {
        view: 'business-events.view',
        manage: 'business-events.manage',
        retry: 'business-events.retry',
    },
    reporting: {
        templates: {
            view: 'reporting.templates.view',
            create: 'reporting.templates.create',
            edit: 'reporting.templates.edit',
            publish: 'reporting.templates.publish',
            preview: 'reporting.templates.preview',
        },
        sql: {
            view: 'reporting.sql.view',
            edit: 'reporting.sql.edit',
            execute: 'reporting.sql.execute',
            export: 'reporting.sql.export',
            publish: 'reporting.sql.publish',
        }
    },
    developer_platform: {
        view: 'developer-platform.view',
        credentials: {
            manage: 'developer-platform.credentials.manage',
        },
        playground: {
            use: 'developer-platform.playground.use',
        },
        usage: {
            view: 'developer-platform.usage.view',
        },
        rate_limits: {
            manage: 'developer-platform.rate-limits.manage',
        },
        webhooks: {
            manage: 'developer-platform.webhooks.manage',
        },
    },
    fuel_management: {
        marketplace: {
            view: 'fuel.marketplace.view',
        },
        connections: {
            manage: 'fuel.connections.manage',
        },
        transactions: {
            view: 'fuel.transactions.view',
            reconcile: 'fuel.transactions.reconcile',
        },
        reports: {
            view: 'fuel.reports.view',
        }
    },
    audit: {
        dashboard: {
            view: 'audit.dashboard.view',
        },
        programs: {
            view: 'audit.programs.view',
            manage: 'audit.programs.manage',
        },
        templates: {
            view: 'audit.templates.view',
            manage: 'audit.templates.manage',
            publish: 'audit.templates.publish',
        },
        cases: {
            view: 'audit.cases.view',
            create: 'audit.cases.create',
            edit: 'audit.cases.edit',
            start: 'audit.cases.start',
            submit: 'audit.cases.submit',
            review: 'audit.cases.review',
            close: 'audit.cases.close',
            reopen: 'audit.cases.reopen',
        },
        findings: {
            view: 'audit.findings.view',
            manage: 'audit.findings.manage',
        },
        actions: {
            view: 'audit.actions.view',
            manage: 'audit.actions.manage',
            verify: 'audit.actions.verify',
        },
        evidence: {
            view: 'audit.evidence.view',
            upload: 'audit.evidence.upload',
        },
        reports: {
            view: 'audit.reports.view',
            generate: 'audit.reports.generate',
        },
        automation: {
            view: 'audit.automation.view',
            manage: 'audit.automation.manage',
        },
        settings: {
            view: 'audit.settings.view',
            manage: 'audit.settings.manage',
        }
    },
    hr: {
        dashboard: {
            view: 'hr.dashboard.view',
        },
        employees: {
            view: 'hr.employees.view',
            create: 'hr.employees.create',
            edit: 'hr.employees.edit',
            status: 'hr.employees.status',
            link: 'hr.employees.link',
        },
        org: {
            view: 'hr.org.view',
            manage: 'hr.org.manage',
        },
        migration: {
            view: 'hr.migration.view',
            manage: 'hr.migration.manage',
        },
        documents: {
            view: 'hr.documents.view',
            manage: 'hr.documents.manage',
            verify: 'hr.documents.verify',
            restrictedView: 'hr.documents.restricted.view',
        },
        adminOperations: {
            view: 'hr.admin-operations.view',
            manage: 'hr.admin-operations.manage',
            complete: 'hr.admin-operations.complete',
            verify: 'hr.admin-operations.verify',
            setup: 'hr.admin-operations.setup',
            restrictedView: 'hr.admin-operations.restricted.view',
            importExport: 'hr.admin-operations.import-export',
        },
        documentTypes: {
            view: 'hr.document-types.view',
            manage: 'hr.document-types.manage',
        },
        lifecycle: {
            view: 'hr.lifecycle.view',
            manage: 'hr.lifecycle.manage',
        },
        onboarding: {
            view: 'hr.onboarding.view',
            manage: 'hr.onboarding.manage',
        },
        offboarding: {
            view: 'hr.offboarding.view',
            manage: 'hr.offboarding.manage',
        },
        readiness: {
            view: 'hr.readiness.view',
            manage: 'hr.readiness.manage',
            override: 'hr.readiness.override',
        },
        qualifications: {
            view: 'hr.qualifications.view',
            manage: 'hr.qualifications.manage',
        },
        leave: {
            view: 'hr.leave.view',
            request: 'hr.leave.request',
            approve: 'hr.leave.approve',
            manage: 'hr.leave.manage',
        },
        time: {
            view: 'hr.time.view',
            manage: 'hr.time.manage',
            approve: 'hr.time.approve',
            adjust: 'hr.time.adjust',
        },
        biometric: {
            view: 'hr.biometric.view',
            manage: 'hr.biometric.manage',
        },
        countryPacks: {
            view: 'hr.countrypacks.view',
            manage: 'hr.countrypacks.manage',
            employeeManage: 'hr.countrypacks.employee.manage',
            exportsManage: 'hr.countrypacks.exports.manage',
        },
        recruitment: {
            view: 'hr.recruitment.view',
            manage: 'hr.recruitment.manage',
            offersManage: 'hr.recruitment.offers.manage',
        },
        learning: {
            view: 'hr.learning.view',
            manage: 'hr.learning.manage',
            assign: 'hr.learning.assign',
            complete: 'hr.learning.complete',
        },
        labor: {
            view: 'hr.labor.view',
            profilesManage: 'hr.labor.profiles.manage',
            ratesView: 'hr.labor.rates.view',
            ratesManage: 'hr.labor.rates.manage',
            assign: 'hr.labor.assign',
            workSubmit: 'hr.labor.work.submit',
            workApprove: 'hr.labor.work.approve',
            override: 'hr.labor.override',
            financeGenerate: 'hr.labor.finance.generate',
        },
        performance: {
            view: 'hr.performance.view',
            manage: 'hr.performance.manage',
            review: 'hr.performance.review',
            calibrate: 'hr.performance.calibrate',
        },
        cases: {
            view: 'hr.cases.view',
            manage: 'hr.cases.manage',
            confidentialView: 'hr.cases.confidential.view',
            accessManage: 'hr.cases.access.manage',
            disciplinaryManage: 'hr.cases.disciplinary.manage',
            sealedView: 'hr.cases.sealed.view',
        },
        self: {
            view: 'hr.self.view',
            manage: 'hr.self.manage',
        },
        manager: {
            view: 'hr.manager.view',
            approve: 'hr.manager.approve',
        },
        analytics: {
            view: 'hr.analytics.view',
            manage: 'hr.analytics.manage',
            export: 'hr.analytics.export',
            aiView: 'hr.analytics.ai.view',
            periodLock: 'hr.analytics.period.lock',
            override: 'hr.analytics.override',
        },
        roster: {
            view: 'hr.roster.view',
            manage: 'hr.roster.manage',
            publish: 'hr.roster.publish',
        },
        payroll: {
            view: 'hr.payroll.view',
            manage: 'hr.payroll.manage',
            calculate: 'hr.payroll.calculate',
            approve: 'hr.payroll.approve',
            payslipView: 'hr.payroll.payslip.view',
            accountingView: 'hr.payroll.accounting.view',
            accountingManage: 'hr.payroll.accounting.manage',
            accountingPost: 'hr.payroll.accounting.post',
            paymentManage: 'hr.payroll.payment.manage',
        }
    },
    onboarding: {
        start: 'onboarding.start',
        manage: 'onboarding.manage',
    },
    crm: {
        dashboard: {
            view: 'crm.dashboard.view',
        },
        leads: {
            create: 'crm.leads.create',
            edit: 'crm.leads.edit',
            view: 'crm.leads.view',
            delete: 'crm.leads.delete',
            convert: 'crm.leads.convert',
        },
        prospects: {
            create: 'crm.prospects.create',
            edit: 'crm.prospects.edit',
            view: 'crm.prospects.view',
            delete: 'crm.prospects.delete',
            convert: 'crm.prospects.convert',
        },
        clients: {
            create: 'crm.clients.create',
            edit: 'crm.clients.edit',
            view: 'crm.clients.view',
            delete: 'crm.clients.delete',
            approve: 'crm.clients.approve',
        },
        accounts: {
            create: 'crm.accounts.create',
            edit: 'crm.accounts.edit',
            view: 'crm.accounts.view',
            delete: 'crm.accounts.delete',
        },
        merchandisers: {
            create: 'crm.merchandisers.create',
            edit: 'crm.merchandisers.edit',
            view: 'crm.merchandisers.view',
            delete: 'crm.merchandisers.delete',
        },
        assignments: {
            view: 'crm.assignments.view',
            manage: 'crm.assignments.manage',
        },
        quotations: {
            create: 'crm.quotations.create',
            edit: 'crm.quotations.edit',
            view: 'crm.quotations.view',
            delete: 'crm.quotations.delete',
            approve: 'crm.quotations.approve',
            convert_contract: 'crm.quotations.convert-contract',
            convert_sales_order: 'crm.quotations.convert-sales-order',
        },
        terms: {
            manage: 'crm.terms.manage',
        },
        activities: {
            create: 'crm.activities.create',
            edit: 'crm.activities.edit',
            delete: 'crm.activities.delete',
        }
    },
    posm: {
        projects: {
            create: 'posm.projects.create',
            edit: 'posm.projects.edit',
            view: 'posm.projects.view',
            delete: 'posm.projects.delete',
            update_status: 'posm.projects.update-status',
        },
        planning: {
            manage: 'posm.planning.manage',
        }
    },
    logisticsProjects: {
        projects: {
            create: 'logistics-projects.projects.create',
            edit: 'logistics-projects.projects.edit',
            view: 'logistics-projects.projects.view',
            delete: 'logistics-projects.projects.delete',
            changeStatus: 'logistics-projects.projects.change-status',
            close: 'logistics-projects.projects.close',
            reopen: 'logistics-projects.projects.reopen',
        },
        programs: {
            view: 'logistics-projects.programs.view',
            create: 'logistics-projects.programs.create',
            edit: 'logistics-projects.programs.edit',
        },
        links: {
            view: 'logistics-projects.links.view',
            manage: 'logistics-projects.links.manage',
        },
        financials: {
            groupView: 'logistics-projects.financials.group.view',
        },
        timeline: {
            view: 'logistics-projects.timeline.view',
        },
        audit: {
            view: 'logistics-projects.audit.view',
        }
    },
    warehousing: {
        overview: {
            view: 'warehousing.overview.view',
        },
        items: {
            create: 'warehousing.items.create',
            edit: 'warehousing.items.edit',
            view: 'warehousing.items.view',
            delete: 'warehousing.items.delete',
        },
        stock_entry: {
            create: 'warehousing.stock-entry.create',
            edit: 'warehousing.stock-entry.edit',
            view: 'warehousing.stock-entry.view',
            post: 'warehousing.stock-entry.post',
        },
        stock: {
            view: 'warehousing.stock.view',
            adjust: 'warehousing.stock.adjust',
        },
        quality: {
            view: 'warehousing.quality.view',
            release: 'warehousing.quality.release',
            reject: 'warehousing.quality.reject',
        },
        dispatch: {
            create: 'warehousing.dispatch.create',
            edit: 'warehousing.dispatch.edit',
            view: 'warehousing.dispatch.view',
            approve: 'warehousing.dispatch.approve',
            release: 'warehousing.dispatch.release',
        },
        transfer: {
            create: 'warehousing.transfer.create',
            edit: 'warehousing.transfer.edit',
            view: 'warehousing.transfer.view',
            release: 'warehousing.transfer.release',
            receive: 'warehousing.transfer.receive',
            cancel: 'warehousing.transfer.cancel',
        },
        refurbishment: {
            create: 'warehousing.refurbishment.create',
            edit: 'warehousing.refurbishment.edit',
            view: 'warehousing.refurbishment.view',
            update_status: 'warehousing.refurbishment.update-status',
        },
        destruction: {
            create: 'warehousing.destruction.create',
            view: 'warehousing.destruction.view',
            confirm: 'warehousing.destruction.confirm',
            cancel: 'warehousing.destruction.cancel',
        },
        billing: {
            view: 'warehousing.billing.view',
            generate: 'warehousing.billing.generate',
            edit: 'warehousing.billing.edit',
            approve: 'warehousing.billing.approve',
        },
        setup: {
            create: 'warehousing.setup.create',
            edit: 'warehousing.setup.edit',
            view: 'warehousing.setup.view',
            delete: 'warehousing.setup.delete',
            manage_rates: 'warehousing.setup.manage-rates',
        }
    },
    workflow: {
        view: 'workflow.view',
        manage: 'workflow.manage',
    },
    flex_fields: {
        view: 'flex-fields.view',
        manage: 'flex-fields.manage',
    },
    productivity: {
        notifications: {
            view: 'productivity.notifications.view',
            manage: 'productivity.notifications.manage',
        },
        tasks: {
            create: 'productivity.tasks.create',
            edit: 'productivity.tasks.edit',
            view: 'productivity.tasks.view',
            delete: 'productivity.tasks.delete',
            update_status: 'productivity.tasks.update-status',
        },
        incidents: {
            create: 'productivity.incidents.create',
            edit: 'productivity.incidents.edit',
            view: 'productivity.incidents.view',
            delete: 'productivity.incidents.delete',
            update_status: 'productivity.incidents.update-status',
            resolve: 'productivity.incidents.resolve',
        }
    }
};
